import { createWebSocketStore } from 'src/components/#services/helpers';
export const getPolygonWithdrawAccountBalance = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'evm-adapter',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'wallet_getWithdrawAccountBalances',
    },
});
export const polygonDeposits = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'evm-adapter',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'processedDeposit_getAllByFilter',
    },
});
export const getUserProfileByEvmWallet = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'evm-adapter',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'wallet_getUserByPublicKey',
    },
});
export const getUserPolygonWallet = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'evm-adapter',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'wallet_getPublicKeyByUserId',
    },
});
